import { ADULT_BMI_STANDARDS, CHILD_BMI_STANDARDS } from '../healthConstants';
import { BMIStatus, Gender } from '../healthTypes';

export const calculateAge = (birthDate: string): number => {
  if (!birthDate) return 0;
  const birth = new Date(birthDate);
  if (isNaN(birth.getTime())) return 0;
  const today = new Date();
  let age = today.getFullYear() - birth.getFullYear();
  const m = today.getMonth() - birth.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) {
    age--;
  }
  return age;
};

export const calculateBMI = (weightKg: number, heightCm: number): number => {
  if (heightCm <= 0) return 0;
  const heightM = heightCm / 100;
  const bmi = weightKg / (heightM * heightM);
  return parseFloat(bmi.toFixed(1));
};

export const getBMIStatus = (bmi: number, age: number, gender: Gender): BMIStatus => {
  if (age >= 18) {
    if (bmi < 24 && bmi < 18.5) return BMIStatus.Underweight;
    if (bmi < 24) return BMIStatus.Normal;
    if (bmi < 28) return BMIStatus.Overweight;
    return BMIStatus.Obese;
  }

  if (age < 7) {
    const standard = CHILD_BMI_STANDARDS.find(s => s.age === 7 && s.gender === gender);
    if (!standard) return BMIStatus.Normal;
    if (bmi >= standard.obesity) return BMIStatus.Obese;
    if (bmi >= standard.overweight) return BMIStatus.Overweight;
    if (bmi <= standard.malnutrition) return BMIStatus.Underweight;
    return BMIStatus.Normal;
  }

  const standard = CHILD_BMI_STANDARDS.find(s => s.age === age && s.gender === gender);

  if (!standard) {
    if (bmi < 24) return BMIStatus.Normal;
    if (bmi >= 28) return BMIStatus.Obese;
    return BMIStatus.Overweight;
  }

  if (bmi >= standard.obesity) return BMIStatus.Obese;
  if (bmi >= standard.overweight) return BMIStatus.Overweight;
  if (bmi <= standard.malnutrition) return BMIStatus.Underweight;

  return BMIStatus.Normal;
};

export const getStatusColor = (status: BMIStatus): string => {
  switch (status) {
    case BMIStatus.Underweight: return 'text-amber-500 bg-amber-50 border-amber-200';
    case BMIStatus.Normal: return 'text-emerald-600 bg-emerald-50 border-emerald-200';
    case BMIStatus.Overweight: return 'text-orange-500 bg-orange-50 border-orange-200';
    case BMIStatus.Obese: return 'text-red-600 bg-red-50 border-red-200';
    default: return 'text-slate-500 bg-slate-50 border-slate-200';
  }
};

export const getStatusLabel = (status: BMIStatus): string => {
  switch (status) {
    case BMIStatus.Underweight: return '偏瘦 (营养不良)';
    case BMIStatus.Normal: return '正常';
    case BMIStatus.Overweight: return '超重';
    case BMIStatus.Obese: return '肥胖';
    default: return '未知';
  }
};


